// Validatore di lunghezza per l'input testuale di Customily
// Luca Siviero

document.addEventListener("DOMContentLoaded", () => {

    const productId = window.product?.id;

    const CONFIG = {
        11858695094540: { // Cappello
            "Century Gothic":     { riga: 16, righe: 2 },
            "French Script MT":   { riga: 16, righe: 2 },
            "Gabriola":           { riga: 16, righe: 2 },
            "Lucida Calligraphy": { riga: 16, righe: 2 },
            "Lucida Handwriting": { riga: 16, righe: 2 },
            "Vivaldi":            { riga: 18, righe: 2 },
            "Arial":              { riga: 16, righe: 2 },
            "Times New Roman":    { riga: 16, righe: 2 },
        },
        11858715345164: { // Bavetta
            "Century Gothic":     { riga: 15, righe: 2 },
            "French Script MT":   { riga: 16, righe: 2 },
            "Gabriola":           { riga: 16, righe: 2 },
            "Lucida Calligraphy": { riga: 16, righe: 2 },
            "Lucida Handwriting": { riga: 16, righe: 2 },
            "Vivaldi":            { riga: 16, righe: 2 },
            "Arial":              { riga: 16, righe: 2 },
            "Times New Roman":    { riga: 16, righe: 2 },
        },
        11858731499788: { // Body
            "Century Gothic":     { riga: 15, righe: 2 },
            "French Script MT":   { riga: 16, righe: 2 },
            "Gabriola":           { riga: 16, righe: 2 },
            "Lucida Calligraphy": { riga: 15, righe: 2 },
            "Lucida Handwriting": { riga: 15, righe: 2 },
            "Vivaldi":            { riga: 16, righe: 2 },
            "Arial":              { riga: 15, righe: 2 },
            "Times New Roman":    { riga: 15, righe: 2 },
        },
        11858701877516: { // TShirt
            "Century Gothic":     { riga: 16, righe: 2 },
            "French Script MT":   { riga: 16, righe: 2 },
            "Gabriola":           { riga: 16, righe: 2 },
            "Lucida Calligraphy": { riga: 16, righe: 2 },
            "Lucida Handwriting": { riga: 16, righe: 2 },
            "Vivaldi":            { riga: 16, righe: 2 },
            "Arial":              { riga: 16, righe: 2 },
            "Times New Roman":    { riga: 16, righe: 2 },
        },
    };

    const CONFIG_DEFAULT = { riga: 16, righe: 2 };

    function getSelectedFont() {
        const checked = document.querySelector('input[name="properties[Font]"]:checked');
        return checked ? checked.value.trim() : null;
    }

    function getLimiti() {
        const font = getSelectedFont() || "Arial";
        const prodConfig = CONFIG[productId] || {};
        return prodConfig[font] || CONFIG_DEFAULT;
    }

    function toggleCartButton(disable) {
        const btns = document.querySelectorAll('#customily-cart-btn, buy-buttons button[type="submit"]');
        btns.forEach((btn) => {
            btn.disabled = disable;
            btn.style.opacity = disable ? '0.6' : '1';
            btn.style.pointerEvents = disable ? 'none' : 'auto';
        });
    }

    function syncCustomily(element) {
        element.dispatchEvent(new Event('input', { bubbles: true }));
        element.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function getVisibleTextarea() {
        return [...document.querySelectorAll('textarea[name^="properties[Testo personalizzato"]')]
            .find(el => {
                const option = el.closest('.customily_option');
                return option && option.style.transform === 'translateX(0%)';
            }) || document.querySelector('textarea[name="properties[Testo personalizzato]"]');
    }

    const observer = new MutationObserver(() => {
        const textInput = getVisibleTextarea();
        if (!textInput) return;
        if (textInput._counterAttached) return;
        textInput._counterAttached = true;

        document.querySelector('#char-counter')?.remove();

        const parent = textInput.closest('.cl-option-content');
        if (!parent) return;

        const counter = document.createElement('div');
        counter.id = 'char-counter';
        counter.style.marginTop = '6px';
        counter.style.fontSize = '14px';
        counter.style.fontFamily = 'inherit';
        counter.style.color = '#444';
        counter.style.textAlign = 'right';

        const spacer = parent.querySelector('.bottom-spacer');
        if (spacer) parent.insertBefore(counter, spacer);
        else parent.appendChild(counter);

        textInput.addEventListener('input', (e) => {
            if (textInput._syncing) return;

            const isUserInput = e.isTrusted;
            const { riga: maxRiga, righe: maxRighe } = getLimiti();
            const valore = textInput.value;
            const righe = valore.split('\n');

            // Controlla numero massimo di righe
            if (righe.length > maxRighe) {
                const nuovoValore = righe.slice(0, maxRighe).join('\n');
                if (textInput.value !== nuovoValore) {
                    if (isUserInput && !textInput.dataset.alerting) {
                        textInput.dataset.alerting = "true";
                        alert(`Massimo ${maxRighe} ${maxRighe === 1 ? 'riga' : 'righe'} consentite.`);
                        setTimeout(() => delete textInput.dataset.alerting, 500);
                    }
                    textInput._syncing = true;
                    textInput.value = nuovoValore;
                    syncCustomily(textInput);
                    textInput._syncing = false;
                }
                counter.style.color = '#dc2626';
                counter.textContent = `Limite di ${maxRighe} righe raggiunto!`;
                toggleCartButton(false);
                return;
            }

            // Controlla riga per riga
            let rigaViolata = -1;
            for (let i = 0; i < righe.length; i++) {
                if (righe[i].length > maxRiga) {
                    rigaViolata = i;
                    break;
                }
            }

            if (rigaViolata >= 0) {
                righe[rigaViolata] = righe[rigaViolata].substring(0, maxRiga);
                const nuovoValore = righe.join('\n');
                if (textInput.value !== nuovoValore) {
                    if (isUserInput && !textInput.dataset.alerting) {
                        textInput.dataset.alerting = "true";
                        alert(`La riga ${rigaViolata + 1} supera il limite di ${maxRiga} caratteri per riga.`);
                        setTimeout(() => delete textInput.dataset.alerting, 500);
                    }
                    textInput._syncing = true;
                    textInput.value = nuovoValore;
                    syncCustomily(textInput);
                    textInput._syncing = false;
                }
                counter.style.color = '#dc2626';
                counter.textContent = `Riga ${rigaViolata + 1}: limite di ${maxRiga} caratteri raggiunto!`;
                toggleCartButton(false);
                return;
            }

            // Stato normale
            const rigaMax = Math.max(...righe.map(r => r.length));
            counter.textContent = `Riga più lunga: ${rigaMax}/${maxRiga} — ${righe.length}/${maxRighe} righe`;
            counter.style.color = '#444';
            toggleCartButton(false);
        });

        const fontInputs = document.querySelectorAll('input[name="properties[Font]"]');
        fontInputs.forEach(f => f.addEventListener('change', () => {
            textInput.dispatchEvent(new Event('input'));
        }));

        textInput.dispatchEvent(new Event('input'));
    });

    observer.observe(document.body, { childList: true, subtree: true });
});